import { useMutation, useQueryClient } from '@tanstack/react-query';
import _ from 'lodash';
import { toast } from 'react-toastify';

import { GoodLocation } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface SaveGoodLocationProps {
  goodLocation: GoodLocation;
  declarantId: string;
}

export const useSaveGoodLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ goodLocation, declarantId }: SaveGoodLocationProps) => {
      const isUpdate = goodLocation._id && goodLocation._id.length > 0;
      if (!isUpdate) {
        goodLocation = _.omit(goodLocation, ['_id']) as GoodLocation;
      }
      try {
        const response = await request({
          path: `declarant/${declarantId}/good-location`,
          method: isUpdate ? 'PATCH' : 'POST',
          dataObject: goodLocation,
          authenticate: true,
        });
        return response.data;
      } catch (error: any) {
        if (error.response?.data?.message) {
          throw new Error(error.response.data.message);
        }
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['good-locations'] });
      toast.success('Good location saved successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error saving the good location!`);
    },
  });
};
